import { render } from "./page-sitemap.vue?vue&type=template&id=bbddde32"
import script from "./page-sitemap.js?vue&type=script&lang=js"
export * from "./page-sitemap.js?vue&type=script&lang=js"

import "./page-sitemap.vue?vue&type=style&index=0&id=bbddde32&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__